/*** ELX add : Contenu des médias (titre, description, bouton) qui suit le scroll ***/
if (!customElements.get("sticky-content")) {
  class StickyContent extends HTMLElement {
    constructor() {
      super();
      this.update = this.update.bind(this);
    }

    connectedCallback() {
      this.resizeObserver = new ResizeObserver(this.update);
      this.resizeObserver.observe(this);
      this.resizeObserver.observe(this.parentElement);
      window.addEventListener("resize", this.update);
      this.update();
    }

    disconnectedCallback() {
      this.resizeObserver.disconnect();
      window.removeEventListener("resize", this.update);
    }

    // Seuil sticky des positions "milieu" : le contenu reste centré dans la partie visible du média, sous le header
    update() {
      const headerHeight = parseFloat(getComputedStyle(document.documentElement).getPropertyValue("--header_section_height")) || 0;
      const visibleHeight = Math.min(this.parentElement.offsetHeight, window.innerHeight);
      const top = Math.max(headerHeight, (visibleHeight - this.offsetHeight) / 2);
      this.style.setProperty("--sticky-top", `${Math.round(top)}px`);
    }
  }

  customElements.define("sticky-content", StickyContent);
}
